module.exports = __webpack_public_path__ + "static/icon-pledge-3-63eee9ac903a751e57512638ef442ac3.svg";